import { HttpParameterCodec, HttpParams } from '@angular/common/http';

export const strictQueryEncoder: HttpParameterCodec = {
  encodeKey: (key: string): string => encodeURIComponent (key),
  encodeValue: (value: string): string => encodeURIComponent (value),
  decodeKey: (key: string): string => decodeURIComponent (key),
  decodeValue: (value: string): string => decodeURIComponent (value),
}

export function createStrictQueryParams(params: Record<string, string>): HttpParams {
  let httpParams = new HttpParams ({ encoder: strictQueryEncoder });

  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null) {
      httpParams = httpParams.set(key, value);
    }
  }

  return httpParams;
}
